export const LOGO_GOLD = "https://customer-assets.emergentagent.com/job_4b74f5e0-16c3-461d-8255-e994cba0b7f0/artifacts/p0bzlo4u_Digital%20Beast%20-%20Black%20Logo%20Gold.png";
export const LOGO_BLUE = "https://customer-assets.emergentagent.com/job_4b74f5e0-16c3-461d-8255-e994cba0b7f0/artifacts/m9p0ngpw_Digital%20Beast%20-%20Black%20Logo%20Midnight%20blue.png";
export const LOGO_METAL = "https://customer-assets.emergentagent.com/job_4b74f5e0-16c3-461d-8255-e994cba0b7f0/artifacts/sycfad6t_Digital%20Beast%20-%20Black%20Logo%20Metal%20Flame%20copy.png";

export const HERO_IMAGES = {
    stadium: "https://images.unsplash.com/photo-1557174949-3b1f5b2e8fac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    football: "https://images.unsplash.com/photo-1485313260896-6e6edf486858?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    basketball: "https://images.unsplash.com/photo-1737392721245-94db2412951c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    training: "https://images.unsplash.com/photo-1546519638-68e109498ffc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    huddle: "https://images.unsplash.com/photo-1518050947974-4be8c7469f0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    stadium_lights: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/football", label: "Football", highlight: true },
    { to: "/athletes", label: "Athletes" },
    { to: "/services", label: "Services" },
    { to: "/nil", label: "NIL Management" },
    { to: "/brands", label: "Brands & Sponsors" },
    { to: "/academy", label: "Academy" },
    { to: "/apply", label: "Apply" },
    { to: "/contact", label: "Contact" },
];
